import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../../components/Loader'
import api from "../../api/Api";
import Helmet from 'react-helmet';

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import moment from "moment";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/LocalHospital";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {mappingUI, dashboardRouter, titleCase, getDateConverter} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    FacebookShareCount
} from 'react-share';
const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};
class PrintFileReport extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            notFound: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            selectPic: 0
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.searchOnFilter = this.searchOnFilter.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = (id) => {
        api.getReportList({_id: id})
            .then(json => {
                this.setState({data: json.data.data[0]}, () => {
                    var prtContent = document.getElementById("print-document");
                    var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
                    WinPrint.document.write(prtContent.innerHTML);
                    WinPrint.document.close();
                    WinPrint.focus();
                    WinPrint.print();
                    WinPrint.close();
                });
                if (json.data.isError === false && json.data.data.length === 0) {
                    this.setState({notFound: {"deleted": "yes"}})
                }
            }).catch(error => {
            this.setState({notFound: error})
        });
    };

    componentDidMount() {
        this.CallReadApi(this.props.match.params.id);
    }

    searchOnFilter() {
        this.setState({data: []});
        var postBody = {
            clinic_id: this.state.clinic_id,
            patient_id: this.state.patientId,
            doctor_id: this.state.doctor_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
        };
        api.getReportList(postBody)
            .then(json => {
                this.setState({data: json.data[0]})
            });
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data)
            return (
                <div id="print-document">
                    {this.state.alert}
                    <GridContainer style={{padding: '20px'}}>
                        <Grid item xs={12}>
                            <Card component="div" style={{margin: '10px', padding: '30px'}}>
                                <div style={{padding: "5px"}}>
                                    <GridContainer key={Math.random()}>
                                        <table style={{width: '100%'}}>
                                            <tr>
                                                <td style={{textAlign: 'left'}}><h5>
                                                    <b>{data.patient_id.user_id.name}</b></h5></td>
                                                <td style={{textAlign: 'right'}}><h5><b>
                                                    Date: {data.created_at ? getDateConverter(data.created_at) : null}
                                                </b></h5></td>
                                            </tr>
                                            <tr>
                                                <td style={{textAlign: 'left'}}><h5>
                                                    <b>{data.patient_id.user_id.gender ? data.patient_id.user_id.gender + "," : null} {data.patient_id.user_id.age ? data.patient_id.user_id.age + " Years" : null}
                                                    </b>
                                                </h5></td>
                                                <td style={{textAlign: 'right'}}><h5>
                                                    <b>{data.follow_up_date ? "Follow up: " + getDateConverter(data.follow_up_date) : null}
                                                    </b></h5></td>
                                            </tr>
                                            <tr>
                                                <td style={{textAlign: 'left'}}><h5>
                                                    <b>Ph: {data.patient_id.user_id.contact}</b>
                                                </h5></td>
                                                <td style={{textAlign: 'right'}}/>
                                            </tr>
                                        </table>
                                        <hr/>


                                        <table style={{width: '100%'}}>
                                            <tr>

                                                <td>
                                                    <h3>{data.title}</h3><br/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div>{data.raw_data.text ? data.raw_data.text : ""}</div>
                                                </td>

                                            </tr>
                                        </table>
                                        <hr/>
                                    </GridContainer>
                                    {/*<GridContainer key={Math.random()}>*/}
                                    {/*<div className="right width-full">*/}
                                    {/*<table style={{width: '100%'}}>*/}
                                    {/*<tbody>*/}
                                    {/*<tr>*/}
                                    {/*<td>*/}

                                    {/*</td>*/}
                                    {/*<td className="emr-detail-with-instruction right"*/}
                                    {/*style={{float: 'right'}}>*/}
                                    {/*{data.raw_data.meta_data.docs[0].name}<br/>{data.raw_data.meta_data.docs[0].sign}*/}
                                    {/*</td>*/}
                                    {/*</tr>*/}
                                    {/*</tbody>*/}
                                    {/*</table>*/}
                                    {/*</div>*/}
                                    {/*</GridContainer>*/}
                                </div>
                            </Card>
                        </Grid>

                    </GridContainer>
                </div>
            );
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        }
        else return (
                <div>
                    <Loader/>
                </div>
            )
    }
}
export default withStyles(styles)(PrintFileReport);


// WEBPACK FOOTER //
// ./src/views/PrintFile/PrintFileReport.jsx